var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svgicon',{staticClass:"o-icon",attrs:{"name":_vm.name,"width":_vm.width,"height":_vm.height,"scale":_vm.scale,"dir":_vm.dir,"fill":_vm.fill,"color":_vm.color,"original":_vm.original,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }